import { Grid, styled } from "@mui/material";
import MxIcons from "@rf-l1/MxIcons";
import { IconPhoto } from "@tabler/icons-react";

const EmptyPlaceHolderCarrusel = () => {
  return (
    <ContentEmpty container p={2}>
      <Grid item xs="auto" mx="auto" mt={3}>
        <MxIcons size={64} color="primary.main">
          <IconPhoto stroke={1.6} />
        </MxIcons>
      </Grid>
    </ContentEmpty>
  );
};

export default EmptyPlaceHolderCarrusel;

const ContentEmpty = styled(Grid)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}));
